import React from 'react';
import MaterialGrid, { GridProps } from '@mui/material/Grid';

// exporting Material UI Grid with a bit different API to conform to existing Grid components

export const Col = (props: Omit<GridProps, 'item' | 'container'>): JSX.Element => <MaterialGrid {...props} item container={undefined} />;

export const Row = (props: Omit<GridProps, 'item' | 'container'>): JSX.Element => <MaterialGrid {...props} container item={undefined} />;
